import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CONSENT_EVENT, getAnalyticsConsent } from '../../mixpanel/config';
import { trackHomePageView, trackGuestSpeakerPageView, trackAcademicRecognitionPageView, trackCaseStudyPageView, trackSessionStart } from '../../mixpanel/events';
const trackers = { '/': trackHomePageView, '/guest-speaker-event': trackGuestSpeakerPageView, '/academic-changemaker-recognition': trackAcademicRecognitionPageView, '/delivery-system-case-study': trackCaseStudyPageView };
export default function PageAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    let tracked = false;
    const track = () => {
      if (getAnalyticsConsent() !== 'accepted') { tracked = false; return; }
      if (!tracked && trackers[pathname]) {
        tracked = true;
        trackers[pathname]();
        if (pathname === '/') trackSessionStart();
      }
    };
    track();
    window.addEventListener(CONSENT_EVENT, track);
    return () => window.removeEventListener(CONSENT_EVENT, track);
  }, [pathname]);
  return null;
}
